import React from 'react';
import ReactDOM from 'react-dom';

import i18next from './i18n';
import { I18nextProvider } from 'react-i18next';

import App from './app';

import "bootstrap/dist/js/bootstrap.bundle.min.js"

import * as Sentry from '@sentry/browser';

require("@rails/ujs").start()



Sentry.init({
  dsn: 'https://22f9d90c8fa3484da68a107c74e3de33@sentry.lico.nl/98',
  // integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1,
});

window.Sentry = Sentry

if (typeof Office !== 'undefined') {
  Office.onReady()
    .then(function() {
      console.log("--------------------------------------");
      console.log(window._historyCache);
      // Office js deletes window.history.pushState and window.history.replaceState. Restore them
      window.history.replaceState = window._historyCache.replaceState;
      window.history.pushState = window._historyCache.pushState;
      console.log(window.history.replaceState);

    Office.context.roamingSettings.set('proxy_login', true);

      // VERWIJDEREN VOOR RELEASE
      // Office.context.roamingSettings.set('use_outlook_email', '');
      // END VERWIJDERERN VOOR RELEASE

      if (Office.context.roamingSettings.get('api_token') && Office.context.roamingSettings.get('host')) {
        window.location.replace(Office.context.roamingSettings.get('host'));
      } else {
        ReactDOM.render(
          <I18nextProvider i18n={i18next}>
            <App/>
          </I18nextProvider>
          ,
          document.body.appendChild(document.createElement('div'))
        );
      }
    })
} else {
  document.addEventListener('DOMContentLoaded', function () {
    console.log("loading the webapp");
    ReactDOM.render(
      <I18nextProvider i18n={i18next}>
        <App/>
      </I18nextProvider>
      ,
      document.body.appendChild(document.createElement('div'))
    );
  });
}
